// Login.js
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Item.css'; 

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`http://localhost:5000/api/auth/login`, { email, password }, {withCredentials: true});
      console.log(res.data);
      // Save token or user info if needed
      localStorage.setItem("token", res.data.token);
      navigate('/todos');
    } catch (err) {
      alert('Invalid email or password');
      setEmail('');
      setPassword('');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Login</h2>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email"
        required
        name="email"
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
        required
        name="password"
      />
      <button type="submit">Login</button>
      <p>Don't have an account? <a href="/">Sign up</a></p>
    </form>
  );
}
export default Login;